module.exports = __webpack_public_path__ + "static/img/y3.12b7364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y3.png
// module id = SAwi
// module chunks = 1